var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"header-wrapper"}},[_c('Header')],1),_c('div',{attrs:{"id":"contentContainer"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1),_c('div',[_c('Footer')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }